import ExpandMore from '@material-ui/icons/ExpandMore';
import clsx from 'clsx';
import React, { forwardRef } from 'react';

import { Button } from '../../../../basics';

import { fieldFilterButtonStyles } from './fieldFilterButtonStyles';

export interface FlatButtonProps {
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLSpanElement>;
  hideExpandIcon?: boolean;
  active?: boolean;
  isOpen?: boolean;
  selected?: boolean;
  disabled?: boolean;
}

const rotatingIconStyle = (isOpen: boolean): object => ({
  transform: `rotate(${isOpen ? 180 : 0}deg)`,
});

// eslint-disable-next-line react/display-name
export const FieldFilterFlatButton: React.FC<FlatButtonProps> = forwardRef<HTMLButtonElement, FlatButtonProps>(
  (props, ref) => {
    const classes = fieldFilterButtonStyles({ isReset: false });
    const { active, children, hideExpandIcon, isOpen = false, selected, disabled, ...other } = props;

    return (
      <Button
        className={clsx(classes.root, { [classes.active]: active })}
        component="span"
        disableRipple
        disabled={disabled}
        ref={ref}
        {...other}
        style={{ fontWeight: selected ? 'bold' : 'normal' }}
      >
        {children}
        {hideExpandIcon || !active ? null : (
          <ExpandMore style={rotatingIconStyle(isOpen)} className={clsx(classes.icon)} />
        )}
      </Button>
    );
  }
);

FieldFilterFlatButton.defaultProps = {
  active: true,
  hideExpandIcon: false,
  isOpen: false,
  selected: false,
};
